<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>
<main class="esf-main-content esf-main-content--has-sidebar -has-transition" *ngIf="!loading" (window:scroll)="getScrollPosition()">
  <div class="esf-container" style="margin-left: calc(5vw); margin-right: calc(5vw);">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <div class="esf-action-heading__text">
        <span i18n='Page heading@@clubListComponent.heading.clubs'>Clubs</span>
      </div>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.viewUsers' data-tooltip="View users">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small" [routerLink]="['/manage/users']"
                    [disabled]="!(authenticatedUser.isAdmin)">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-user-data"></use>
              </svg>
            </button>
          </span>
        </span>
        <span class="esf-action-heading__action">
          <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.addClub' data-tooltip="Add new club">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small" (click)="setModalStatus(true)"
                    [disabled]="!(authenticatedUser.isAdmin)">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-plus"></use>
              </svg>
            </button>
          </span>
        </span>
      </span>
    </h1>

    <div class="esf-form-item"
         app-form-field-search
         [placeholder]="flTranslations.i18nSearchByClubName"
         [id]="'search'"
         [control]="searchForm.get('search')"
         (enterPressed)="getCustomerFromSearch($event, true)"
         (inputChanged)="getCustomerFromSearch($event, false)">
    </div>

    <app-spinner [name]="clubLoadSpinner" [(show)]="clubLoadLoading"></app-spinner>
    <div class="esf-tenants-grid" *ngIf="!clubLoadLoading">
      <div class="esf-tenants-grid__item" *ngFor="let club of listOfClubs; let i = index;">
        <div class="esf-info-tile esf-tenant">
          <div class="esf-info-tile__content">
            <div class="esf-tenant__items">
              <div class="esf-tenant__logo" *ngIf="!club.pathToLogo"></div>
              <img class="esf-tenant__logo" *ngIf="club.pathToLogo" alt="club logo" src="{{ club.pathToLogo }}">
              <div class="esf-tenant__info">
                <div class="esf-icon-and-text esf-icon-and-text--xxs">
                  <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                    <use xlink:href="#esf-icon-football"></use>
                  </svg>
                  <span class="esf-icon-and-text__text">Sport</span>
                </div>
                <div class="esf-tenant__name">{{ club.name }}</div>
                <div class="esf-tenant__venue">{{ getAddress(club) }}</div>
              </div>
            </div>
            <ng-container [ngSwitch]="club.status">
              <button *ngSwitchCase="'active'"
                      class="esf-button esf-button--standard esf-button--filled esf-button--wide esf-tenant__button"
                      (click)="selectClub(club)"
                      i18n='Button@@general.button.selectClient'>Select client</button>
              <ng-container *ngSwitchCase="'inactive'" [ngSwitch]="authenticatedUser.isAdmin">
                <button *ngSwitchCase="true"
                        class="esf-button esf-button--standard esf-button--filled esf-button--wide esf-tenant__button"
                        (click)="selectClub(club)">
                  <span i18n='Button@@general.button.selectClient'>Select client</span>
                  (<span i18n='Button@@general.button.disabled'>disabled</span>)
                </button>
                <button *ngSwitchCase="false"
                        class="esf-button esf-button--standard esf-button--filled esf-button--wide esf-tenant__button"
                        i18n='Button@@general.button.disabled'>Disabled</button>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-container>
      <app-spinner [name]="loadMoreSpinner" [(show)]="loadMoreLoading"></app-spinner>
      <button #loadMore class="esf-button esf-button--standard esf-button--filled" style="opacity: 0" *ngIf="!loadMoreLoading && !maxClubs"></button>
    </ng-container>

  </div>
</main>

<ng-container *ngIf="modalOpened">
  <aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open">
    <div class="esf-main-sidebar__content">
      <h3 i18n='Modal title@@clubListComponent.modalTitle.createNewClub'>Create new club</h3>
      <form [formGroup]="clubForm" id="clubCreationForm" (ngSubmit)="createNewClub()">
        <div app-form-field-text-generic
             [control]="clubForm.get('name')"
             [placeholder]="flTranslations.i18nName"
             [label]="flTranslations.i18nName">
        </div>
        <div app-form-field-select
             [control]="clubForm.get('country')"
             [label]="flTranslations.i18nCountry"
             [array]="countries"
             [valueKey]="'iso2'"
             [textKey]="'name'">
        </div>
      </form>
    </div>
  </aside>

  <div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
    <app-submit-row-buttons [cancelButtonText]="buttonsTranslations.i18nBack"
                            [submitButtonText]="buttonsTranslations.i18nSubmit"
                            [form]="'clubCreationForm'"
                            [spinnerName]="spinnerName"
                            (cancelButton)="setModalStatus(false)">
    </app-submit-row-buttons>
  </div>

  <div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open" (click)="setModalStatus(false)">
    <span class="esf-hamburger__icon"></span>
  </div>
</ng-container>
